import React, { useState, useEffect } from 'react';
import { Container, Tabs, Tab, ListGroup, Button, Modal, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const OrgManagement = () => {
  const [organizations, setOrganizations] = useState({ approved: [], unapproved: [] });
  const [loading, setLoading] = useState(true);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await fetch(`/api/admin/manageOrgs`);
        const data = await response.json();
        setOrganizations(data);
      } catch (error) {
        console.error('Error fetching organizations:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, []);

  const handleApproveRedirect = (org) => {
    navigate(`/admin/approveOrg/${org.org_id}`);
  };

  return (
    <Container>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Tabs defaultActiveKey="unapproved" id="organization-tabs" className="mb-3">
          <Tab eventKey="unapproved" title="Unapproved">
            {organizations.unapproved.length > 0 ? (
              <ListGroup>
                {organizations.unapproved.map((org) => (
                  <ListGroup.Item key={org.org_id} className="d-flex justify-content-between align-items-center">
                    {org.org_name}
                    <Button variant="success" onClick={() => handleApproveRedirect(org)}>Approve</Button>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            ) : (
              <p>No unapproved organizations.</p>
            )}
          </Tab>
          <Tab eventKey="approved" title="Approved">
            {organizations.approved.length > 0 ? (
              <ListGroup>
                {organizations.approved.map((org) => (
                  <ListGroup.Item key={org.org_id}>
                    {org.org_name}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            ) : (
              <p>No approved organizations.</p>
            )}
          </Tab>
        </Tabs>
      )}
    </Container>
  );
};

export default OrgManagement;
